import { render } from "./ThirdStep.vue?vue&type=template&id=0f54f39c&scoped=true"
import script from "./ThirdStep.vue?vue&type=script&lang=js"
export * from "./ThirdStep.vue?vue&type=script&lang=js"

import "./ThirdStep.vue?vue&type=style&index=0&id=0f54f39c&scoped=true&lang=css"

import exportComponent from "D:\\Build Apps\\bestphone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f54f39c"]])

export default __exports__